<script>
	export default {
		globalData: {
			// url: 'http://192.168.3.4:9301/crest',
			// brestUrl: 'http://192.168.3.4:9302/brest',
			// imgUrl: 'https://192.168.3.4:9301/filesystem/',
			//正式
			// url: 'https://hsg.dctpay.com/crest',
			// imgUrl: 'https://hsg.dctpay.com/filesystem/',
			// imageWxImg:'https://hsg.dctpay.com/filesystem/wxApplets/',
			//测试
			url: 'https://hlt.dctpay.com/crest',
			brestUrl: 'https://hsgcs.dctpay.com/brest',
			imageWxImg: 'https://hsgcs.dctpay.com/filesystem/wxApplets/',
			userInfo: "",
			openId: '',
			code: '',
			token: '',
		},
	}
</script>

<style lang="scss">
	/*每个页面公共css */
	@import "/static/iconfont/font.scss";

	::-webkit-scrollbar {
		display: none;
		width: 0 !important;
		height: 0 !important;
		-webkit-appearance: none;
		background: transparent;
	}
</style>
